export default __webpack_public_path__ + "static/media/behance-square.f868b98f.svg";